import { createValidationResult, IModelContext, IValidationResult, ModelItem, ValidationFunction } from '@mng/model';
import { GvPerson, GvTarif, GvTarifData } from '../gvangebot.model.types';
import { isGvTarifValid } from '@mng/salesmodel';

export const gvTarifValidation: ValidationFunction = (
  modelItem: ModelItem,
  modelContext: IModelContext
): IValidationResult => {
  const gvTarif: GvTarif = modelContext.value;
  return isGvTarifValid(gvTarif);
};

export const gvTarifDataValidation: ValidationFunction = (
  modelItem: ModelItem,
  modelContext: IModelContext
): IValidationResult => {
  const gvTarifData: GvTarifData = modelContext.value;
  const gvPerson: GvPerson = modelContext.dataStack[modelContext.dataStack.length - 2];

  // console.log('gvTarifDataValidation', modelContext.dataStack);
  if (gvPerson.personRollen.vp && (!gvTarifData || !gvTarifData.tarife || gvTarifData.tarife.length === 0)) {
    return createValidationResult('gvTarifData', null, 'Für VP sind keine GV Tarife vorhanden');
  }

  return null;
};
